// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__uCFWk","desktop":"Container_desktop__35haU"};